import { render } from "./PremiumImpact.vue?vue&type=template&id=0aef29b6&scoped=true"
import script from "./PremiumImpact.vue?vue&type=script&lang=js"
export * from "./PremiumImpact.vue?vue&type=script&lang=js"

import "./PremiumImpact.vue?vue&type=style&index=0&id=0aef29b6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aef29b6"]])

export default __exports__